import React, { useEffect } from 'react';
import Cookies from 'js-cookie';

import EnrollmentBanner from '@components/libraryV2/EnrollmentBanner';
import Header from '@components/libraryV2/Header';
import Footer from '@components/libraryV2/Footer';
import dayjs from '@lib/dayjs';
import { isEmpty } from '@lib/helpers';
import getParsedUrlParams from '@lib/getParsedUrlParams';
import { trackAdrollView } from '@lib/tracking';

const ROOT_DOMAIN = process.env.ROOT_DOMAIN; // eslint-disable-line prefer-destructuring

const setFirstSource = ({ foundSource }) => {
  const firstSourceCookie = Cookies.get('firstSource');
  if (firstSourceCookie) return;

  Cookies.set('firstSource', foundSource, { domain: ROOT_DOMAIN });
};

const Layout = (props) => {
  useEffect(() => {
    trackAdrollView();

    const now = dayjs().valueOf();

    const firstSeenAtCookie = Cookies.get('firstSeenAt');
    if (!firstSeenAtCookie) {
      Cookies.set('firstSeenAt', now, { domain: ROOT_DOMAIN });
    }

    // eslint-disable-line class-methods-use-this
    const { hash, search } = window.location;

    if (isEmpty(search) && isEmpty(hash)) {
      setFirstSource({ foundSource: 'organic' });
      return;
    }

    const { foundPromo, foundSource } = getParsedUrlParams({ hash, search });

    if (foundSource) {
      Cookies.set('utmSource', foundSource, {
        domain: ROOT_DOMAIN,
        expires: 60,
      });
      Cookies.set('utmSourceAt', now, { domain: ROOT_DOMAIN, expires: 60 });
    }

    setFirstSource({ foundSource: foundSource || 'organic' });

    if (foundPromo) {
      Cookies.set('promo', foundPromo, { domain: ROOT_DOMAIN, expires: 60 });
      Cookies.set('promoAt', now, { domain: ROOT_DOMAIN, expires: 60 });
    }

    if (window.heap) {
      window.heap.addUserProperties({
        source: foundSource,
        promo: foundPromo,
      });
    }
  }, []);

  const { banner, children, secondary } = props;

  return (
    <React.Fragment>
      <Header />
      <EnrollmentBanner />
      {banner}
      <main className="content">{children}</main>
      <Footer secondary={secondary} />
    </React.Fragment>
  );
};

export default Layout;
